import { API_REQUEST } from ".";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { filterSubscriptionAPI, getAllSubscriptionAPI } from "../../routes/apiEndPoints";


export const fetchSubscription = createAsyncThunk("Get-all-subscription",async () => {
    try {
      const response = await API_REQUEST({ 
        url: getAllSubscriptionAPI,
        method: "GET",
      })
      return response;
    } catch (error) {

     }
  });


//filter-subscription
export const filterSubscription = createAsyncThunk("filter-subscription", async (props) => {
    const {payload} = props
    const { plan_type, plan_name} = payload;
    const params = {};
    if (plan_type) params.plan_type = plan_type;
    if (plan_name) params.plan_name = plan_name;
    try {
      const response = await API_REQUEST({
        url: filterSubscriptionAPI,
        method: "GET",
        params: params,
      });
      return response;
    } catch (error) {}
  });